/**
 * @generated SignedSource<<f6926eec70f8ef2edaa48f5ad76da916>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplaceStickyHeader_viewer$data = {
  readonly isMultiItemCart: boolean | null;
  readonly " $fragmentType": "PdpRespMarketplaceStickyHeader_viewer";
};
export type PdpRespMarketplaceStickyHeader_viewer$key = {
  readonly " $data"?: PdpRespMarketplaceStickyHeader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceStickyHeader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespMarketplaceStickyHeader_viewer",
  "selections": [
    {
      "alias": "isMultiItemCart",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "multiItemCart"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"multiItemCart\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "6e9b433e6ac7dbfde87949d73c75c106";

export default node;
